/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Step3_ArtifactInputs */

const en_dr_step3_artifact = /** @type {(inputs: Dr_Step3_ArtifactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assumption cards mapped by importance × certainty → riskiest hypothesis + a cheap test`)
};

const id_dr_step3_artifact = /** @type {(inputs: Dr_Step3_ArtifactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kartu asumsi dipetakan penting × belum-yakin → hipotesis paling berisiko + uji murah`)
};

/**
* | output |
* | --- |
* | "Assumption cards mapped by importance × certainty → riskiest hypothesis + a cheap test" |
*
* @param {Dr_Step3_ArtifactInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_step3_artifact = /** @type {((inputs?: Dr_Step3_ArtifactInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Step3_ArtifactInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_step3_artifact(inputs)
	return en_dr_step3_artifact(inputs)
});